import BasicService from "./BasicService";

class IncomeService extends BasicService {
    constructor() {
        super();
    }

    //   income
    deleteIncome(income) {
        let url = `/incomes/${income.incomeId}`;
        return this.axios.delete(url, income).then(request => request.data);
    }
    updateIncome(income) {
        let url = `/incomes/${income.incomeId}/transactions/${income.transactionDto.transactionId}`;
        return this.axios.put(url, income).then(request => request.data);
    }
    addIncome(income) {
        let url = `/incomes`;
        return this.axios.post(url, income).then(request => request.data);
    }
    getIncome(pagination,typeId,reportTitle,type) {
        let url = `/incomes`;
        return this.axios.get(url,{
            params: {
                pagination,
                typeId,
                reportTitle,
                type,
            }
        }).then(request => request.data);
    }

    //   Income Type
    getIncomeType() {
        let url = `/incometypes`;
        return this.axios.get(url).then(request => request.data);
    }
    deleteIncomeType(income) {
        let url = `/incometypes/${income.incomeTypeId}`;
        return this.axios.delete(url, income).then(request => request.data);
    }
    updateIncomeType(income) {
        let url = `/incometypes/${income.incomeTypeId}`;
        return this.axios.put(url, income).then(request => request.data);
    }
    addIncomeType(income) {
        let url = `/incometypes`;
        return this.axios.post(url, income).then(request => request.data);
    }
}

const incomeService = new IncomeService();
export default incomeService;